var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"earth-wrapper",on:{"click":_vm.goTo}},[_c('div',{ref:"earth",staticClass:"earth-container",on:{"click":() => _vm.trackEvent('LandingPage', 'ClickOnEarthImg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }